import { Injectable } from '@angular/core';
import {  Resolve } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import { Component } from "@angular/core";
import { AuthService, UserModel, UserService } from "@bt/core";
import * as $ from 'jquery';
import { BaseComponent } from "@bt/core/base";
import { debug } from "util";

@Injectable()
export class LoadPageResolve  extends BaseComponent implements Resolve<boolean>{

   

   constructor(private userService: UserService) {
       super();
   }

    async resolve(){
    var t=this;
    var isCanLoad=false;
    function waiting(ms) {
        return new Promise(resolve => setTimeout(resolve, ms))
    }
    t.setLoading(true);
    while(!isCanLoad){
        isCanLoad=true;
        if(t.userService.getRole()==null){
            t.userService.getMe();
            isCanLoad=false;
        }
        await waiting(800);
    };
    t.setLoading(false);
    return true;
   }
}









// WEBPACK FOOTER //
// ./src/app/loadPageResolve.ts